import { createContext, useContext } from 'react';

const RefContext = createContext<HTMLElement | null>(null);

export const RefProvider = RefContext.Provider;

export const useRefContainer = () => {
  return useContext(RefContext);
};
